import React from 'react';

const Page = React.lazy(() => import('./ChildrenWithoutContractReportPage'));

const ChildrenWithoutContractReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/children-without-contract',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default ChildrenWithoutContractReportConfig;
